
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'MemberJoin',
    data() {
        return {
            "test1": "test msg",
        }
    },
    components: {
    },
    methods: {
        async click_ok(){
            this.$router.push("/JoinAgree");
        },
        "test": function (): string {
            return "test";
        },
    },

});
